import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ConnectionState } from './connection-sign.reducers';
import { StoreSelector } from '../store-selector.const';

export const selectConnectionState = createFeatureSelector<ConnectionState>(StoreSelector.Connection);

export const selectIsConnected =
{
  isConnected: createSelector(
    selectConnectionState,
    (state: ConnectionState) => state.isConnected
  ),
}
